export const RegisterTranslations = {
  en: {
    register: {
      title: "Welcome to Ecochillers",
      subtitle: "Create an account to run and keep your performances.",
      emailLabel: "Email",
      emailInvalid: "Please enter a valid email.",
      fullNameLabel: "Full Name",
      fullNameInvalid: "Please enter your full name.",
      phoneLabel: "Phone Number",
      phoneInvalid: "Please enter a valid phone number.",
      countryLabel: "Country",
      countryInvalid: "Please enter your country.",
      companyLabel: "Company",
      companyInvalid: "Please enter your company name.",
      passwordLabel: "Password",
      passwordInvalid: "Please provide a valid password (min 6 characters).",
      confirmPasswordLabel: "Confirm Password",
      passwordsDoNotMatch: "Passwords do not match.",
      confirmPasswordInvalid: "Please confirm your password (min 6 characters).",
      registerButton: "Register",
      alreadyMember: "Already a member?",
      loginAction: "Log In",
    },
  },

  es: {
    register: {
      title: "Bienvenido a Ecochillers",
      subtitle: "Crea una cuenta para calcular y guardar tus hojas de performance.",
      emailLabel: "Correo electrónico",
      emailInvalid: "Por favor ingresa un correo válido.",
      fullNameLabel: "Nombre completo",
      fullNameInvalid: "Por favor ingresa tu nombre completo.",
      phoneLabel: "Teléfono",
      phoneInvalid: "Por favor ingresa un número de teléfono válido.",
      countryLabel: "País",
      countryInvalid: "Por favor ingresa tu país.",
      companyLabel: "Empresa",
      companyInvalid: "Por favor ingresa el nombre de tu empresa.",
      passwordLabel: "Contraseña",
      passwordInvalid: "Por favor ingresa una contraseña válida (mínimo 6 caracteres).",
      confirmPasswordLabel: "Confirmar contraseña",
      passwordsDoNotMatch: "Las contraseñas no coinciden.",
      confirmPasswordInvalid: "Por favor confirma tu contraseña (mínimo 6 caracteres).",
      registerButton: "Registrarse",
      alreadyMember: "¿Ya tienes cuenta?",
      loginAction: "Iniciar sesión",
    },
  },
};
